import objectPath from 'object-path'
import {
  deleteData,
  getData,
  patchData,
  postData,
  putData,
  setApi,
  setRequestData,
} from '../Action'
import {
  checkConditionApi,
  createApiSchema,
  setTableApi,
} from 'designer/component/action/Api'
import httpClient from 'utility/httpClient.util'
import { Resolver } from '@stoplight/json-ref-resolver'

export const crud = async (props) => {
  let { action } = props
  let { method } = action
  if (method === 'get') {
    await getData(props)
  } else if (method === 'post') {
    await postData(props)
  } else if (method === 'put') {
    await putData(props)
  } else if (method === 'patch') {
    await patchData(props)
  } else if (method === 'delete') {
    await deleteData(props)
  }
}

export const checkCrudCondition = (props) => {
  let { action, designContext, allParams } = props
  const { jsonForm, tabParamActive } = designContext
  const formData = jsonForm.formData
  const datasourceValue = objectPath.get(designContext, '@datasource')
  let { apiCondition = [] } = action
  let responseData = formData
  let filterApi = apiCondition.filter((item) => {
    let isPassCondition = checkConditionApi(
      item,
      allParams,
      responseData,
      datasourceValue,
      tabParamActive,
    )
    return isPassCondition
  })
  return filterApi
}

export const crudCondition = async (props) => {
  let filterApi = checkCrudCondition(props)
  if (filterApi) {
    return Promise.all(
      filterApi.map((item) => crud({ ...props, action: item })),
    )
  }
  return Promise.resolve()
}
